import { z } from 'zod'
import { oc } from '@orpc/contract'
import { REFERRAL_SPECIALTY_CODES } from '../referral-specialties.schema'
import { latSchema, lonSchema, referralDoctorSchema } from './referral-discovery-views.schema'

// No state = all states (the clinician unticked "In {state} only").
export const referralDiscoveryDoctorsInputSchema = z
  .object({
    specialtyCode: z.enum(REFERRAL_SPECIALTY_CODES),
    name: z.string().trim().min(2).max(80),
    state: z.string().length(2).toUpperCase().optional(),
    lat: latSchema.optional(),
    lon: lonSchema.optional(),
    // The patient's ZIP: ranks a long NPPES match list before the top few are geocoded.
    zip: z.string().trim().max(10).optional(),
  })
  .refine((v) => (v.lat === undefined) === (v.lon === undefined), {
    message: 'lat and lon must be given together',
  })

export const referralDiscoveryDoctors = oc
  .route({ method: 'GET', path: '/v2/referral-discovery/doctors' })
  .input(referralDiscoveryDoctorsInputSchema)
  .output(z.object({ doctors: z.array(referralDoctorSchema) }))
